import { ref, shallowRef, markRaw } from 'vue'

// Mapa de caminhoComponente → import() dinâmico
const mapaComponentes = {
  'relatorios/templates/purchase-order/PurchaseOrderRelatorio':
    () => import('@/components/relatorios/templates/purchase-order/PurchaseOrderRelatorio.vue'),
  'relatorios/templates/purchase-order/PurchaseOrderRelatorioGerencial':
    () => import('@/components/relatorios/templates/purchase-order/PurchaseOrderRelatorioGerencial.vue'),
  'relatorios/templates/purchase-order/PurchaseOrderRelatorioFornecedorIngles':
    () => import('@/components/relatorios/templates/purchase-order/PurchaseOrderRelatorioFornecedorIngles.vue'),
  'relatorios/templates/ordem-compra/OrdemCompraRelatorio':
    () => import('@/components/relatorios/templates/ordem-compra/OrdemCompraRelatorio.vue')
}

// Mapa de caminhoComponente → dadosMock
const mapaMocks = {
  'relatorios/templates/purchase-order/PurchaseOrderRelatorio':
    () => import('@/components/relatorios/templates/purchase-order/PurchaseOrderRelatorioMock.js')
      .then(m => m.dadosMockPurchaseOrder),
  'relatorios/templates/purchase-order/PurchaseOrderRelatorioGerencial':
    () => import('@/components/relatorios/templates/purchase-order/PurchaseOrderRelatorioGerencialMock.js')
      .then(m => m.dadosMockPurchaseOrderGerencial),
  'relatorios/templates/purchase-order/PurchaseOrderRelatorioFornecedorIngles':
    () => import('@/components/relatorios/templates/purchase-order/PurchaseOrderRelatorioFornecedorInglesMock.js')
      .then(m => m.dadosMockPurchaseOrderFornecedorIngles),
  'relatorios/templates/ordem-compra/OrdemCompraRelatorio':
    () => import('@/components/relatorios/templates/ordem-compra/OrdemCompraRelatorioMock.js')
      .then(m => m.dadosMockOrdemCompra)
}

export function useRelatorioTemplate () {
  const componenteAtual = shallowRef(null)
  const isLoading = ref(false)

  const carregarComponente = async (caminho) => {
    isLoading.value = true
    try {
      const importFn = mapaComponentes[caminho]
      if (!importFn) throw new Error(`Template não encontrado: ${caminho}`)
      const mod = await importFn()
      componenteAtual.value = markRaw(mod.default)
    } finally {
      isLoading.value = false
    }
  }

  const obterDadosMock = async (caminho) => {
    const importFn = mapaMocks[caminho]
    if (!importFn) return null
    return await importFn()
  }

  return {
    componenteAtual,
    isLoading,
    carregarComponente,
    obterDadosMock
  }
}
